var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_833_5069",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0173 15.837L10.2411 15.8393C15.4481 15.9476 19.6477 19.8247 19.765 24.6304L19.7675 24.8369H0.26709C0.26709 19.8672 4.63179 15.837 10.0173 15.837ZM9.76673 0.836914C13.0208 0.836914 15.6697 3.426 15.7649 6.65694L15.7676 6.83709L15.7649 7.01719C15.6714 10.1888 13.1163 12.7422 9.94361 12.834L9.76673 12.8366L9.58662 12.8339C6.41506 12.7404 3.86161 10.1859 3.7698 7.01393L3.76725 6.83709L3.7699 6.65694C3.86512 3.426 6.51336 0.836914 9.76673 0.836914Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_833_5069)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.23291 27.3371H22.2675V-1.66357H-2.23291V27.3371Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9415ff7d1799abdf05812ebb48c497f6.svg";
export { ForwardRef as ReactComponent };